import { bind } from "@/apis/sdkhb";
import { sort_ASCII } from "@/libs/utils";

const state = {
  userInfo: ""
}

const mutations = {
  CHANGE_USERINFO(state, obj) {
    state = Object.assign(state, obj);
  },
  CLEAR_USERINFO(state) {
    state.userInfo = "";
  },
  CHANGE_USER_STATUS(state, status) {
    state.userInfo.status = status;
  },
  CHANGE_USER_NAME(state, user_name) {
    state.userInfo.user_name = user_name;
  }
}

const actions = {
  async userBind({ commit }, data) {
    const r = await bind(data);
    if (r.ret === 1) {
      commit("CHANGE_USER_STATUS", r.content.status);
      commit("CHANGE_USER_NAME", r.content.user_name);
    }
    return r;
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}